import { useBootstrapApi } from '@aibees/elephant/hooks/bootstrap/use-bootstrap-api';
import { Grid2, Icon } from '@aibees/shared/components';
import { classnames, fHumanReadableNumber } from '@aibees/shared/utils';
import { Avatar, Card, Skeleton, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PreviewTotalDataProps as Props } from './types';

export const PreviewTotalData = memo(({ className }: Props) => {
  const { data } = useBootstrapApi();
  const totalPeople = fHumanReadableNumber(data?.person.count.total);
  const totalCompany = fHumanReadableNumber(data?.company.count.total);

  return (
    <Styled.Wrapper
      className={classnames('PreviewTotalData', className)}
      container
      sx={SX.root}
      columns={48}
    >
      <Grid2 xs={48} md={28} lg={32} flexDirection="column" gap={1}>
        <Stack direction="row" gap={1.25} alignItems="center">
          <Avatar
            src="assets/images/ark-logo.svg"
            alt="logo"
            variant="rounded"
            size={32}
          />

          <Typography variant="body1" fontWeight={700} sx={SX.title}>
            Open the Ark: Discover Your Data Potential
          </Typography>
        </Stack>
        <Typography variant="body4" fontWeight={400} color="primary.700">
          Find the perfect tools to navigate your data landscape, enrich your
          insights, and prospect with precision.
        </Typography>
      </Grid2>

      <Grid2
        xs={48}
        md={20}
        lg={16}
        flexDirection="row"
        justifyContent="end"
        gap={1}
      >
        <Card variant="elevation" sx={SX.card}>
          <Stack direction="row" gap={0.6} alignItems="center" mb={0.5}>
            <Typography variant="body3" fontWeight={400} color="grey.600">
              Global Companies
            </Typography>
            <Icon name="business" size={18} color="primary.600" />
          </Stack>
          {totalCompany ? (
            <Typography variant="body1" fontWeight={600} color="black">
              {totalCompany}
            </Typography>
          ) : (
            <Skeleton animation="wave" variant="rounded" sx={SX.skeleton} />
          )}
        </Card>
        <Card variant="elevation" sx={SX.card}>
          <Stack direction="row" gap={0.6} alignItems="center" mb={0.5}>
            <Typography variant="body3" fontWeight={400} color="grey.600">
              Global Contacts
            </Typography>
            <Icon name="people" size={18} color="primary.600" />
          </Stack>
          {totalPeople ? (
            <Typography variant="body1" fontWeight={600} color="black">
              {totalPeople}
            </Typography>
          ) : (
            <Skeleton animation="wave" variant="rounded" sx={SX.skeleton} />
          )}
        </Card>
      </Grid2>
    </Styled.Wrapper>
  );
});

PreviewTotalData.displayName = 'PreviewTotalData';
